<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" label="Name" />
        </div>
        <div>
          <label class="label-input">Content</label>
          <!-- <ckeditor :editor="editor" v-model="fields['content']" :config="editorConfig" /> -->
          <v-checkbox v-model="fields['container-page']" label="Container Page" />
          <div class="mb-7">
            <div class="d-flex justify-space-between align-center">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label style="margin-bottom: 0">Banner</label>
              </div>
              <v-btn small text color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Banner {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-5">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-checkbox v-model="item.textBanner.showText" label="Show Text" />
                      <ckeditor :editor="editor" v-model="item.textBanner.text" :config="editorConfig" />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-checkbox v-model="item.overlay.showOverlay" label="Show Overlay" />
                      <!-- <v-text-field v-model="item.overlay.opacity" label="Opacity" /> -->
                      <div class="mb-5">
                        <v-subheader class="pl-0"> Overlay Opacity </v-subheader>
                        <v-slider
                          v-model="item.overlay.opacity"
                          class="align-center"
                          :step="0.1"
                          :max="1"
                          :min="0"
                          hide-details
                          thumb-label="always"
                        >
                        </v-slider>
                      </div>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-text-field v-model="item.button.text" label="Button Text" />
                      <v-checkbox v-model="item.button.showBtn" label="Show Button" />
                      <v-text-field v-model="item.button.link" label="Button Link" />
                      <!-- <v-text-field v-model="item.button.background" label="Button Background" /> -->
                      <div style="margin-bottom: 20px">
                        <label>Button Background</label>
                        <div>
                          <div class="d-flex align-center gap-3">
                            <input
                              type="color"
                              name="head"
                              style="width: 40px; height: 40px; margin-right: 12px"
                              :value="item.button.background"
                              @change="event => handleChangeButtonBackground(event, i)"
                            />
                            <v-text-field v-model="item.button.background" label="Color" />
                          </div>
                        </div>
                      </div>
                      <!-- <v-text-field v-model="item.button.color" label="Button Color" /> -->
                      <div style="margin-bottom: 20px">
                        <label>Button Color</label>
                        <div>
                          <div class="d-flex align-center gap-3">
                            <input
                              type="color"
                              name="head"
                              style="width: 40px; height: 40px; margin-right: 12px"
                              :value="item.button.color"
                              @change="event => handleChangeButtonColor(event, i)"
                            />
                            <v-text-field v-model="item.button.color" label="Color" />
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
export default {
  name: 'banner-slider-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'container-page': false,
        'list-item': [
          {
            image: '',
            textBanner: {
              text: '',
              showText: false,
            },
            button: {
              text: '',
              showBtn: false,
              link: '',
              background: '',
              color: '',
            },
            overlay: {
              showOverlay: false,
              opacity: 0.2,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, i) {
      this.fields['list-item'][i].image = obj.imageSrc;
    },
    handleRemoveUpload(i) {
      this.fields['list-item'][i].image = '';
    },
    handleAddItem() {
      this.fields['list-item'].push({
        image: '',
        textBanner: {
          text: '',
          showText: false,
        },
        button: {
          text: '',
          showBtn: false,
          link: '',
          background: '',
          color: '',
        },
        overlay: {
          showOverlay: false,
          opacity: 0.2,
        },
      });
    },
    handleRemoveItem(i) {
      this.fields['list-item'].splice(i, 1);
    },
    handleChangeButtonBackground(event, i) {
      this.fields['list-item'][i].button.background = event.target.value;
    },
    handleChangeButtonColor(event, i) {
      this.fields['list-item'][i].button.color = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
